import React from 'react';

import { DiplomaDetailsPageLayout } from './DiplomaDetailsPageLayout';

const DiplomaDetailsPageContainer: React.FC = () => {

	return (
		<React.Fragment>
			<DiplomaDetailsPageLayout/>
		</React.Fragment>
	);
};

export default DiplomaDetailsPageContainer;